import { lunchMenuView, type ViennaToday } from '@pulsify/shared'
import type { FullMenuDto, IsoWeekday, LunchMenuDto, LunchMenuInput } from '@pulsify/shared/dto'

interface LunchMenuSummary {
  kind: 'lunch'
  /** The Monday of a one-week board; null when it is the same every week. */
  weekOf: string | null
  weekdays: IsoWeekday[]
  dishCount: number
  updatedAt: string
  /** Guests see it today; false once its week is over. */
  visibleToday: boolean
}

interface FullMenuSummary {
  kind: 'full'
  sectionTitles: string[]
  dishCount: number
  updatedAt: string
}

export type MenuSummary = LunchMenuSummary | FullMenuSummary

export function summarizeLunchMenu(menu: LunchMenuDto, today: ViennaToday): LunchMenuSummary {
  const days = menu.days.filter((day) => day.dishes.length > 0)
  return {
    kind: 'lunch',
    weekOf: menu.weekOf,
    weekdays: days.map((day) => day.weekday).sort((a, b) => a - b),
    dishCount: days.reduce((sum, day) => sum + day.dishes.length, 0),
    updatedAt: menu.updatedAt,
    visibleToday: lunchMenuView(menu, today) !== null,
  }
}

/** Whether a Mittagsmenü just saved is on the place page, or waits for a day with dishes. */
export function lunchPublishedNotice(
  menu: Pick<LunchMenuInput, 'weekOf' | 'days'>,
  today: ViennaToday,
): 'live' | 'not_visible' {
  return lunchMenuView(menu, today) ? 'live' : 'not_visible'
}

export function summarizeFullMenu(menu: FullMenuDto): FullMenuSummary {
  return {
    kind: 'full',
    sectionTitles: menu.sections.map((section) => section.title),
    dishCount: menu.sections.reduce((sum, section) => sum + section.dishes.length, 0),
    updatedAt: menu.updatedAt,
  }
}
